/**
 * カンマ区切り
 */
const commaFormat = (num: { toLocaleString: () => string }) => num.toLocaleString();

export default commaFormat;
